import { Observable } from 'rxjs';
import { AccountsManagementRepository } from '../domain/accounts_management/repository';
import HttpClient from '../utils/http-client';

export class AccountsManagementRepositoryImplementation extends AccountsManagementRepository {
    getReceivableSummary(uid: string, cid: string | null, page = 1, limit = 20, query = ""): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        const params = { page, limit, query };
        return httpClient.get<any>(`/accounts/receivable`, params);
    }

    getPayableSummary(uid: string, cid: string | null, page = 1, limit = 20, query = ""): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        const params = { page, limit, query };
        return httpClient.get<any>(`/accounts/payable`, params);
    }

    registerReceivablePayment(uid: string, cid: string | null, accountId: number, data: any): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post<any>(`/accounts/receivable/${accountId}/payment`, data);
    }

    registerPayablePayment(uid: string, cid: string | null, accountId: number, data: any): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post<any>(`/accounts/payable/${accountId}/payment`, data);
    }
}
